<div class="relative">
  <button
    (click)="toggle()"
    class="relative inline-flex items-center justify-center w-9 h-9 rounded-lg hover:bg-stone-100 text-stone-500 hover:text-stone-800 transition-colors"
    aria-label="Notifications"
  >
    <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
    </svg>
    @if (unreadCount() > 0) {
      <span class="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-primary-500 text-white text-[10px] font-bold flex items-center justify-center">
        {{ unreadCount() > 9 ? '9+' : unreadCount() }}
      </span>
    }
  </button>

  @if (isOpen()) {
    <div class="fixed inset-0 z-40" (click)="close()"></div>
    <!-- Phones: full-width sheet under the header; from sm up: dropdown anchored to the bell. -->
    <div class="fixed left-3 right-3 top-[4.75rem] sm:absolute sm:left-auto sm:right-0 sm:top-full sm:mt-2 sm:w-80 bg-white border border-stone-100 rounded-xl shadow-lg z-50 overflow-hidden">
      <div class="px-4 py-3 border-b border-stone-100 flex items-center justify-between">
        <span class="text-sm font-semibold text-stone-800">Notifications</span>
        @if (unreadCount() > 0) {
          <button (click)="markAllRead()" class="text-xs font-medium text-primary-600 hover:text-primary-700">Tout marquer comme lu</button>
        }
      </div>

      <div class="max-h-[60vh] sm:max-h-96 overflow-y-auto">
        @if (notifications().length === 0) {
          <div class="px-4 py-8 text-center text-stone-400 text-sm">Aucune notification.</div>
        } @else {
          @for (n of notifications(); track n.message_fed_seq) {
            <button
              (click)="onNotificationClick(n)"
              class="w-full text-left px-4 py-3 border-b border-stone-50 transition-colors flex items-start gap-2.5"
              [class.bg-primary-50]="!n.read_at"
              [class.hover:bg-primary-100]="!n.read_at"
              [class.hover:bg-stone-50]="!!n.read_at"
            >
              @if (!n.read_at) {
                <span class="w-2 h-2 rounded-full bg-primary-500 mt-1.5 flex-shrink-0"></span>
              } @else {
                <span class="w-2 h-2 flex-shrink-0"></span>
              }
              <div class="min-w-0 flex-1">
                <div class="flex items-center justify-between gap-2">
                  <span class="text-xs font-semibold" [class.text-primary-700]="!n.read_at" [class.text-stone-500]="!!n.read_at">{{ humanizeEventKey(n.event_key) }}</span>
                  <span class="text-[11px] text-stone-400 flex-shrink-0">{{ timeAgo(n.created_at) }}</span>
                </div>
                <div class="text-sm leading-snug mt-0.5" [class.text-stone-800]="!n.read_at" [class.font-medium]="!n.read_at" [class.text-stone-500]="!!n.read_at">{{ n.body }}</div>
              </div>
            </button>
          }
        }
      </div>
    </div>
  }
</div>
